<template>
    <!-- eslint-disable-next-line vue/no-v-html vue/this-in-template -->
    <div class="inline-block" v-html="require(`!!html-loader!icons/icon-${this.icon}.svg`)"></div>
</template>

<style module>
.svg {
    fill: currentColor;
    vertical-align: middle;
}
</style>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true
        }
    },

    mounted() {
        this.$el.firstChild.classList.add('svg');
        this.$el.firstChild.classList.add('icon');
        this.$el.firstChild.removeAttribute('height');
        this.$el.firstChild.removeAttribute('width');
    }
};
</script>
